export enum BorderRadius {
  none = "0px",
  sm = "4px",
  md = "8px",
  lg = "12px",
  xl = "16px",
}

export type BorderRadiusType = keyof typeof BorderRadius;
